export default __webpack_public_path__ + "static/media/accessibility.ca279654.svg";